import { cs as datePickerLocaleCs, enUS as datePickerLocaleEn } from "date-fns/locale";
import Countries from "const/Countries";

export default class Languages {
  static EN = {
    code: "en",
    name: "English",
    defaultCountryCode: Countries.US,
    dateFnsLocale: datePickerLocaleEn
  };

  static CS = {
    code: "cs",
    name: "Čeština",
    defaultCountryCode: Countries.CZ,
    dateFnsLocale: datePickerLocaleCs
  };
}
